import i18n from '@/i18n'

export default [
    {
        value: i18n.t('situationAcademicFormation.braided'),
        label: i18n.t('situationAcademicFormation.braided'),
    },
    {
        value: i18n.t('situationAcademicFormation.in_progress'),
        label: i18n.t('situationAcademicFormation.in_progress'),
    },
    {
        value: i18n.t('situationAcademicFormation.concluded'),
        label: i18n.t('situationAcademicFormation.concluded'),
    },
]
